import { Form, Modal } from "antd";
import React from "react";
import { CreateWaterDrainageProductionDto } from "../../../../api";
import { WaterDrainageProductionColumns } from "../form/columns";

interface WaterDrainageProductionFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateWaterDrainageProduction: (values: CreateWaterDrainageProductionDto) => void;
}

export const WaterDrainageProductionForm: React.FC<WaterDrainageProductionFormProps> = ({ visible, setVisible, onCreateWaterDrainageProduction }) => {
  const [form] = Form.useForm<CreateWaterDrainageProductionDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateWaterDrainageProduction}>
        {WaterDrainageProductionColumns().map(({ title, key, rules, inputNode, hideOnForm }, index) => (
          <>
            {!hideOnForm && <Form.Item label={title} name={key} rules={rules} key={index}>
              {inputNode}
            </Form.Item>}
          </>
        ))}
      </Form>
    </Modal>
  );
};
